import { cn } from "@/lib/utils";
import { StarIcon } from "lucide-react";
import { useState } from "react";

type TRatingStarsProps = {
	rating: number;
	readOnly?: boolean;
	className?: string;
	setRating?: (newRating: number) => void;
	classNames?: { star?: string; starContainer?: string };
};

export const Stars = ({
	rating,
	setRating,
	className,
	classNames,
	readOnly = false,
}: TRatingStarsProps) => {
	const maxRating = 5;
	const [hoveredRating, setHoveredRating] = useState(0);

	const handleRatingChange = (value: number) => {
		if (!readOnly && setRating) setRating(value);
	};

	const handleStarHover = (value: number) => {
		setHoveredRating(value);
	};

	const handleStarLeave = () => {
		setHoveredRating(0);
	};

	return (
		<div className={cn("flex items-center justify-between", className)}>
			{Array(maxRating)
				.fill(null)
				.map((_, index) => {
					const value = index + 1;
					const isFilledStar = value <= rating || value <= hoveredRating;

					return (
						<div key={value} className={cn("h-10 w-10", classNames?.starContainer)}>
							<span
								className={cn(
									"cursor-pointer text-2xl",
									isFilledStar ? "text-yellow-500" : "text-gray-300",
									readOnly
										? "pointer-events-none"
										: hoveredRating >= value
										? "hover:fill-yellow duration-250 transition-all ease-out"
										: ""
								)}
								onClick={() => handleRatingChange(value)}
								onMouseEnter={() => handleStarHover(value)}
								onMouseLeave={handleStarLeave}
							>
								<StarIcon
									className={cn(
										"duration-250 h-9 w-9 fill-current transition-all ease-out hover:h-10 hover:w-10",
										classNames?.star
									)}
								/>
							</span>
						</div>
					);
				})}
		</div>
	);
};
